import React, { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';

import { ClientType } from '@/types/app';

type Props = PropsWithChildren;

interface ChildProps extends PropsWithChildren {
  onClick: () => void;
  isSelected?: boolean;
}

const InfluenzaFilters = ({ children }: Props) => {
  return <Wrapper>{children}</Wrapper>;
};

const Filter = ({ children, onClick, isSelected }: ChildProps) => {
  return (
    <FilterWrapper isSelected={isSelected} onClick={onClick}>
      {children}
    </FilterWrapper>
  );
};

const Refresh = ({ children, onClick }: ChildProps) => {
  return <RefreshWrapper onClick={onClick}>{children}</RefreshWrapper>;
};

export default InfluenzaFilters;
InfluenzaFilters.Filter = Filter;
InfluenzaFilters.Refresh = Refresh;

const Wrapper = styled.div`
  position: sticky;
  top: ${({ theme }) =>
    theme.client.clientType === ClientType.MOBILE_WEB ? 120 : 60}px;
  background-color: ${({ theme }) => theme.color.white};
  display: flex;
  overflow-x: scroll;
  white-space: nowrap;
  align-items: center;
  gap: 8px;
  padding: 12px 24px 12px 0;
  margin-left: 24px;
`;

const FilterWrapper = styled.button<{ isSelected?: boolean }>`
  ${({ theme, isSelected }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px;
    border-radius: 40px;
    height: 36px;
    background: ${isSelected ? theme.color.primary100 : theme.color.gray30};
    border: 1px solid
      ${isSelected ? theme.color.primary600 : theme.color.gray30};
    & > span {
      ${theme.typography.UI14R}
      color: ${isSelected ? theme.color.primary700 : theme.color.gray700};
    }
    & > * + * {
      margin-left: 2px;
    }
    & path {
      fill: ${isSelected ? theme.color.primary700 : theme.color.gray700};
    }
  `}
`;

const RefreshWrapper = styled.button`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 0 12px;
    border-radius: 40px;
    height: 36px;
    background: ${theme.color.gray30};
    border: 1px solid ${theme.color.gray30};
  `}
`;
